import { Box, useTheme } from '@material-ui/core';
import { Agent, Channel } from '@nemuru-eng/js-api-client';

import { Font } from '../../../../../../shared/components/Font';
import { IconButton } from '../../../../../../shared/components/IconButton';
import { useTranslation } from '../../../../../../shared/hooks/useTranslation';
import { useListPagination } from '../../_shared/hooks/useListPagination';
import { ChannelList } from './components/ChannelList';

interface ChannelListWithPaginationProps {
  agentSearchTerm: string;
  channelList: Channel[];
  merchantId: string;
  selectedChannelKey: number | undefined;
  selectChannel: (key: number) => void;
  agentFoundBySearch?: Agent;
  isChannelRedirectAllowed?: boolean;
}

export const ChannelListWithPagination = ({
  agentSearchTerm,
  channelList,
  merchantId,
  selectedChannelKey,
  selectChannel,
  agentFoundBySearch,
  isChannelRedirectAllowed,
}: ChannelListWithPaginationProps) => {
  const { palette } = useTheme();
  const { getTextIdTranslation } = useTranslation();

  const { pagedItems: channels, page, rowsPerPage, onPrev, onNext, disablePrev, disableNext, itemsLength } =
    useListPagination({
      items: channelList,
      rowsPerPage: 6,
      selectedIndex: selectedChannelKey,
      onNavigate: selectChannel,
    });

  return (
    <>
      <Box className={'channels-container'} p="2px">
        <ChannelList
          agentSearchTerm={agentSearchTerm}
          merchantId={merchantId}
          channels={channels}
          selectedChannelKey={selectedChannelKey}
          selectChannel={selectChannel}
          agentFoundBySearch={agentFoundBySearch}
          isChannelRedirectAllowed={isChannelRedirectAllowed}
          page={page}
          rowsPerPage={rowsPerPage}
        />
      </Box>
      {!!itemsLength && (
        <Box className={'channels-pagination'} px={1} style={{ paddingBottom: 4 }}>
          <Font variant="caption" style={{ color: palette.text.secondary }}>
            {`${(page - 1) * rowsPerPage + 1}-${
              itemsLength && page * rowsPerPage > itemsLength ? itemsLength : page * rowsPerPage
            } ${getTextIdTranslation('OF')} ${itemsLength}`}
          </Font>
          <IconButton icon="chevron_left" size="small" onClick={onPrev} disabled={disablePrev} />
          <IconButton icon="chevron_right" size="small" onClick={onNext} disabled={disableNext} />
        </Box>
      )}
    </>
  );
};
